import {
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import Layout from '@src/components/layout/Layout';

import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { RegionLookUps } from '@src/constants/Regions';
import { useState } from 'react';
import useCreateHospitalLazy from '@src/adapters/hooks/hospital/useCreateHospitalLazy';
import HospitalsForm, { HospitalFormValues } from './component/HospitalsForm';
import { useNavigationStore } from '@src/adapters/stores/useNavigationStore';

const PREFIX = 'HospitalCreate';

const FORM_ID = 'hospital-create-form';

const classes = {
  pageTitle: `${PREFIX}-pageTitle`,
  field: `${PREFIX}-field`,
};

const StyledLayout = styled(Layout)(({ theme }) => ({
  [`& .${classes.pageTitle}`]: {
    marginBottom: '33px',
  },
  [`& .${classes.field}`]: {
    width: '438px',

    '& .MuiInputBase-root': {
      height: '56px',
    },

    '& .MuiInputBase-input': {
      color: theme.palette.text.secondary,
    },
  },
}));

function HospitalAdd() {
  const { currentOrganisation } = useNavigationStore();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [regionCode, setRegionCode] = useState<string>('');
  const { execute: createHospital } = useCreateHospitalLazy();

  const { reset, register, handleSubmit } = useForm<HospitalFormValues>();

  const onSubmit = async (data: HospitalFormValues) => {
    await createHospital({
      id: currentOrganisation?.id ?? '',
      name: data.name,
      shortCode: data.shortCode,
      codeSet: data.codeSet,
      regionCode: data.regionCode,
    });

    reset();
    enqueueSnackbar('Hospital Added', { variant: 'success' });
    navigate(-1);
  };

  return (
    <StyledLayout>
      <Box sx={{ margin: 'auto', width: 949, height: 256 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          className={classes.pageTitle}>
          <Typography variant="h4">Add new Hospital</Typography>

          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              size="large"
              color="primary"
              onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button
              form={FORM_ID}
              type="submit"
              variant="contained"
              size="large"
              color="primary">
              Finish
            </Button>
          </Stack>
        </Stack>

        <Box>
          <Paper>
            <Typography variant="h6" sx={{ p: 2 }}>
              Hospital details
            </Typography>

            <Divider />
            <HospitalsForm
              formId={FORM_ID}
              fieldClassName={classes.field}
              register={register}
              onSubmit={handleSubmit(onSubmit)}
              regions={RegionLookUps}
              setRegionCode={setRegionCode}
              regionCode={regionCode}
              mode="add"
            />
          </Paper>
        </Box>
      </Box>
    </StyledLayout>
  );
}

export default HospitalAdd;
